<template>
  <block style="padding-bottom: 60px;">
    <template slot="header"
      >Finalizar Alerta:</template
    >
    <div class="body">
      <div class="alert-details">
        <h4 class="section-title">Agregar comentario para la finalización</h4>
        <textarea v-model="finishComment" placeholder="Especificar detalles..."></textarea>
      </div>

      <derivation-list :derivations.sync="derivations"></derivation-list>
    </div>

    <div class="actions">
      <button
        class="button is-primary finish"
        :class="{ 'is-loading': loading }"
        :disabled="loading"
        @click="submit"
      >
        Finalizar Alerta
      </button>
      &nbsp;
      <button class="button is-primary is-outlined cancel" :disabled="loading" @click="cancel">
        Cancelar
      </button>
    </div>
  </block>
</template>

<script>
import STUDENT_ALERT from "../alert/graphql/StudentAlert.gql"
import LIST_ALERT from "../alerts/graphql/ListAlert.gql"
import FINISH_ALERT from "./graphql/FinishAlert.gql"
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"
import DerivationList from "@/components/_base/DerivationList.vue"

export default {
  name: "ProfileFinishAlert",
  mixins: [OverlayedMixin],
  props: {
    alertId: {
      type: String
    }
  },
  data() {
    return {
      finishComment: "",
      derivations: [],
      loading: false,
      studentAlert: {}
    }
  },
  apollo: {
    studentAlert: {
      query: STUDENT_ALERT,
      variables() {
        return {
          alertId: this.alertId
        }
      }
    }
  },
  computed: {
    validDerivations() {
      const derivations = this.derivations.map(d => {
        return {
          userId: d.chosenUser && d.chosenUser.id ? d.chosenUser.id : null,
          message: d.message || null
        }
      })
      return derivations.filter(d => d.userId != null)
    }
  },
  methods: {
    navigateTo(route) {
      this.$emit("hello", route)
    },

    cancel() {
      this.navigateTo({
        state: "app.profile.alert",
        params: {
          alertId: this.alertId
        }
      })
    },

    submit() {
      // Call the graphql mutation
      this.loading = true
      this.$apollo
        .mutate({
          mutation: FINISH_ALERT,
          variables: {
            input: {
              alertId: this.alertId,
              finishComment: this.finishComment || null,
              derivations: this.validDerivations
            }
          },
          refetchQueries: (() => {
            const queries = [
              {
                query: STUDENT_ALERT,
                variables: { alertId: this.alertId }
              }
            ]

            if (
              this.studentAlert &&
              this.studentAlert.student &&
              this.studentAlert.student.data &&
              this.studentAlert.student.data.id
            ) {
              queries.push({
                query: LIST_ALERT,
                variables: { studentId: this.studentAlert.student.data.id }
              })
            }

            return queries
          })()
        })
        .then(data => {
          // Result
          this.loading = false

          // Navigate to alerts list
          this.navigateTo("app.profile.alerts")
        })
        .catch(error => {
          this.loading = false
          console.error(error)
          // TODO: Show error message to user
          alert("Error al finalizar la alerta: " + (error.message || "Error desconocido"))
        })
    }
  },
  components: {
    Block,
    DerivationList
  }
}
</script>

<style scoped>
.body {
  margin-bottom: 20px;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 10px;
  color: var(--color-neutral-90);
}

.alert-details {
  margin-bottom: 35px;
}

.alert-details textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 100px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 10px;
}

.actions {
  margin-top: 30px;
}

.actions .finish {
  padding: 0 35px;
}

.actions .cancel {
  padding: 0 15px;
}
</style>
